import { createStore } from 'vuex';
import { auth } from './auth';
import { companies } from './companies';
import { user } from './user';
import { payments } from './payment';
import { chats } from './chat';
import { notifications } from './notification';

export default createStore({
  modules: {
    auth,
    companies,
    user,
    payments,
    chats,
    notifications,
  },
  state: {
    companyData: null,
    loading: false,
    error: null,
  },
  mutations: {},
  actions: {},
  getters: {},
});
